<div *ngIf="snapshot | async as snap">
  <div *ngIf="downloadURL as url" class="d-flex align-center">
    <img [src]="url" class="mrxs">
    <a [href]="url" target="_blank" rel="noopener">{{file.name}}</a>
  </div> 
</div>